import { formatMetadataKey } from '../core/utils/utils'
import type { NetworkEdgeData } from '../core/types'
import styles from './view-case-graph.module.scss'

export function EdgePropertiesReadonly({ data }: { data: NetworkEdgeData }) {
  return (
    <div className={styles.edgeProperties}>
      <div className={styles.edgePropertyField}>
        <span className={styles.edgePropertyLabel}>Type</span>
        <span className={styles.edgePropertyValue}>{formatMetadataKey(data.type)}</span>
      </div>
      <div className={styles.edgePropertyField}>
        <span className={styles.edgePropertyLabel}>Subtype</span>
        <span className={styles.edgePropertyValue}>{formatMetadataKey(data.subtype)}</span>
      </div>
    </div>
  )
}
